import _ from 'lodash';
import { Record, List } from 'immutable';
import moment from 'moment';
import PhotoHash from './PhotoHash';
import Review from './Review';

const CustomerContextDefaults = {
  bookmarked: false
};

class CustomerContext extends Record(CustomerContextDefaults) {}

const InventoryRecordDefaults = {
  id: null,
  brand: null,
  name: null,
  description: null,
  units: null,
  photo_hash: null,
  price_text: null,
  sale_price_text: null,
  sale_discount_text: null,
  featured: false,
  max_purchase_quantity: null,
  reviews_url: null,
  web_reviews_url: null,
  ratings: [],
  featured: false,
  customer_context: new CustomerContext(),
  slug: null,
  availability: 'available',
  attributes: [],
  reviews: [],
  wine_sku_id: null // DelectabaseInventoryRecords only
};

class InventoryRecord extends Record(InventoryRecordDefaults) {
  constructor(values) {
    values.photo_hash = (values.photo_hash instanceof PhotoHash) ? values.photo_hash : new PhotoHash(values.photo_hash);
    values.customer_context = (values.customer_context instanceof CustomerContext) ? values.customer_context : new CustomerContext(values.customer_context);
    values.reviews = values.reviews.filter((review) => {return !!review;});
    values.reviews = _.map((values.reviews || []), (reviewSet) => {
      let objects = [];
      reviewSet.objects = _.each(reviewSet.objects, (review) => {
        if(review.review) {
          // NOTE: Filtering out reviews without text
          objects.push(review instanceof Review ? review : new Review(review));
        }
      });
      return {
        type: reviewSet.type,
        header: reviewSet.header,
        objects: objects
      };
    });

    super(values);
  }

  get current_price() {
    if(this.sale_price_text) {
      return parseFloat(this.sale_price_text.replace('$', ''));
    }
    return parseFloat(this.price_text.replace('$', ''));
  }

  get full_name() {
    return `${this.brand} ${this.name}`;
  }

  get delectable_rating() {
    return _.find(this.ratings, (rating) => {return rating.type === 'delectable';});
  }

  generateSchemaJSON(extras={}) {
    let store = extras.store;
    let availability;
    switch(this.availability) {
      case 'available':
        availability = 'https://schema.org/InStock';
        break;
      case 'sold_out':
        availability = 'https://schema.org/SoldOut';
        break;
      case 'unavailable':
      default:
        availability = 'https://schema.org/OutOfStock';
        break;
    }
    let json = {
      "@context": "http://schema.org",
      "@type": "Product",
      "name": this.full_name,
      "description": this.description,
      "brand": {
        "@type": "Organization",
        "name": this.brand
      },
      "image": this.photo_hash.getClosestToTarget(1280),
      "offers": {
        "@type": "Offer",
        "priceCurrency": "USD",
        "price": (this.sale_price_text || this.price_text).replace(/\$/, ''),
        "itemCondition": "http://schema.org/NewCondition",
        "availability": availability
      }
    };

    if(store) {
      json.offers.seller = {
        "@type": "Organization",
        "name": store.name
      };
    }

    let delectableRating = this.delectable_rating;
    if(delectableRating) {
      json.aggregateRating = {
        "@type": "AggregateRating",
        "ratingValue": `${delectableRating.object.average_rating}`,
        "ratingCount": `${delectableRating.object.ratings_count}`,
        "worstRating": "1.0", // Not using 6.1, else scores like 9.3 show in google with 4 stars next to 93% shown with 5 stars
        "bestRating": "10.0"
      };
    }

    if(this.reviews) {
      json.review = _.reduce(this.reviews, (arr, obj) => {
        return arr.concat(obj.objects.map((review) => {
          return {
            "@type": "Review",
            "author": review.reviewer_name,
            "datePublished": moment(review.reviewed_at * 1000).format('YYYY-MM-DD'),
            "reviewBody": review.review,
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": `${review.rating}`,
              "worstRating": "1.0",
              "bestRating": "10.0"
            }
          };
        }));
      }, []);
    }

    return json;
  }
}

export default InventoryRecord;



// WEBPACK FOOTER //
// banquet/models/InventoryRecord.js